import type { Dealer } from '~/types/dealer.type'

export async function get(search: string) {
  try {
    const { data } = await useApi<Dealer[]>('/api/dealers/search', {
      key: `get-dealers-by-geolocation-${search}`,
      method: 'POST',
      params: {
        term: search,
      },
    })
    return { dealers: data }
  }
  catch (error) {
    return [error]
  }
}

export async function getDealersByGeolocation(coords: GeolocationCoordinates) {
  try {
    const { data } = await useApi<Dealer[]>('/api/dealers/search', {
      key: `get-dealers-by-geolocation-${coords.latitude}-${coords.longitude}`,
      method: 'POST',
      params: {
        lat: coords.latitude,
        lng: coords.longitude,
      },
    })
    return { dealers: data }
  }
  catch (error) {
    return [error]
  }
}

export async function getDealer(slug: string) {
  const { data } = await useApi<Dealer>(`/api/dealers/${slug}`)
  return data.value
}
